
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";

    @Component
    export default class FilterCheckbox extends Vue {
        @Prop({ default: false })
        value!: boolean;

        selectedValue = this.value;

        valueChanged() {
            this.$emit("input", this.selectedValue);
        }
    }
